import React from "react";
import PropTypes from "prop-types";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import moment from "moment";

// Weekly send/delivery/open counts. WeekStart is the Sunday of each week (PascalCase from the API).
const COLORS = {
  sent: "#0ea5e9",
  delivered: "#10b981",
  opened: "#1a3a5c"
};

const WeeklyTrendChart = ({ data }) => {
  const rows = (data || []).map(d => ({
    week: moment(d.WeekStart).format("MMM DD"),
    Sent: d.Sent,
    Delivered: d.Delivered,
    Opened: d.Opened
  }));

  if (!rows.length) {
    return <div className="chart-empty">No email activity in this range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart data={rows} margin={{ top: 10, right: 20, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="week" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="Sent" stroke={COLORS.sent} strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="Delivered" stroke={COLORS.delivered} strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="Opened" stroke={COLORS.opened} strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};

WeeklyTrendChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      WeekStart: PropTypes.string,
      Sent: PropTypes.number,
      Delivered: PropTypes.number,
      Opened: PropTypes.number
    })
  )
};

export default WeeklyTrendChart;
